import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { Dashboard } from 'entities/Dashboard';

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}`,
    prepareHeaders: (headers) => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          headers.set('Authorization', `Bearer ${JSON.parse(token)}`);
        }
      } catch (error) {
        console.error('Error');
      }
      return headers;
    },
  }),
  tagTypes: ['dashboard'],
  endpoints: (builder) => ({
    getStatistics: builder.query<{ success: boolean; data: Dashboard }, void>({
      query: () => {
        return {
          url: '/dashboard',
          credentials: 'include',
          mode: 'cors',
        };
      },
    }),
  }),
});

export const { useGetStatisticsQuery } = dashboardApi;
